export default {
  loading: false,
  history: {
    id: null,
    order_number: null,
    cte: {},
    invoice: {},
    logistic_provider: null,
    tracking_code: null,
    historic: [],
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-detail/components/sc-pre-invoice-detail-history/store/states.js